import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import RegisterTemplate from './pages/RegisterTemplate';
import UtmGenerator from './pages/UtmGenerator';
import PdfEditor from './pages/PdfEditor';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/lojas" element={<Dashboard />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/registrar-template" element={<RegisterTemplate />} />
        <Route path="/utm" element={<UtmGenerator />} />
        <Route path="/pdf" element={<PdfEditor />} />
      </Routes>
    </Router>
  );
}

export default App;